import { get } from "lodash";
import { ActionType } from "../types/redux";

export const closeBetaModal = () => ({
  type: ActionType.CLOSE_SPLASH
});

export const openBetaModal = () => ({
  type: ActionType.OPEN_SPLASH
});

export const closeFeaturesModal = () => ({
  type: ActionType.CLOSE_FEATURES_PREVIEW
});

export const openFeaturesModal = () => ({
  type: ActionType.OPEN_FEATURES_PREVIEW
});

export const setContent = (payload: unknown) => ({
  type: ActionType.SET_CONTENT,
  payload: {
    programPage: get(payload, "betaProgramPageContent", ""),
    myStable: get(payload, "betaMyStableContent", ""),
    alertMessages: get(payload, "betaProgramAlertMessages", "")
  }
});

export const setWhitelist = (payload: unknown) => ({
  type: ActionType.SET_WHITELIST,
  payload: get(payload, "betaProgramWhiteList", "")
});
